__turbopack_context__.v({
  "boldText": "GRLBDq_boldText",
  "content": "GRLBDq_content",
  "description": "GRLBDq_description",
  "dialog": "GRLBDq_dialog",
  "header": "GRLBDq_header",
});
